// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__LN1W6","boxTitle":"Qualiphy_boxTitle__1hrDC","box":"Qualiphy_box__2w5-e","toggleWrap":"Qualiphy_toggleWrap__1lIhb"};